<div *ngIf="data" class="me-footer-non-medical">
    <div class="me-footer-non-medical--body">
        <div class="container">
            <div class="me-footer-non-medical--body--text">
                {{data.text}}
            </div>
            <div class="me-footer-non-medical--body--links">
                <div class="me-footer-non-medical--body--links--left">
                    <div class="me-footer-non-medical--body--links--left--item">
                        <storyblok-link [classList]="'text-white'" *ngFor="let internalLink of data.internalLinks" [data]="internalLink.url"></storyblok-link>
                    </div>
                    <div class="me-footer-non-medical--body--links--left--separate"></div>
                    <div class="me-footer-non-medical--body--links--left--item">
                        <storyblok-link [classList]="'text-white'" *ngFor="let legalLink of data.legalLinks" [data]="legalLink.url"></storyblok-link>
                    </div>
                </div>
                <div class="me-footer-non-medical--body--links--right">
                    <div class="app-theme me-custom-select">
                        <i class="me-custom-select--global fal fa-globe"></i>
                        <select *ngIf="languageLocale" class="me-custom-select--select" [(ngModel)]="languageLocale" (change)="changeLanguage()">
                            <option class="me-custom-select--option" *ngFor="let lang of languages" value="{{lang.locale}}">
                                {{ lang.name | translate }}
                            </option>
                        </select>
                        <i class="me-custom-select--dropdown fas fa-chevron-down"></i>
                    </div>
                    <div class="app-language me-custom-select" *ngIf="appService.getMeClinicFolder() === 'core' || appService.getMeClinicFolder() === 'ch'">
                        <select class="me-custom-select--select" [(ngModel)]="country" (change)="changeContry()">
                            <option class="me-custom-select--option" *ngFor="let country of countries" value="{{country.locale}}">
                                {{ country.name | translate }}
                            </option>
                        </select>
                        <i class="me-custom-select--dropdown fas fa-chevron-down"></i>
                    </div>
                </div>
            </div>
            <div class="me-footer-non-medical--body--copyright">{{data.copyrightText}}</div>
        </div>
    </div>
</div>